import { SelectMappedProfile } from "SuperAdmin/Components";
import { formItemLayout } from "SuperAdmin/Config/FormLayout";
import { Button, Form, Input, Modal, Radio, Tag, Tooltip } from "antd";
import { getSearchAuthors } from "Explore/Services/Author";
import { useState } from "react";
import CreateRoleForm from "../CreateRoleForm/CreateRoleForm";
import Roles from "../Roles/Roles";
import styles from "./Form.module.scss";

const FormUpdate = ({
  form,
  role,
  onFinishForm,
  setAddedRole,
  profileData,
}) => {
  const [openCreateRole, setOpenCreateRole] = useState(false);
  const handleDeleteMappedProfile = () => {};

  return (
    <div className={styles["update-form"]}>
      <Modal
        title="Basic Modal"
        open={openCreateRole}
        // onOk={handleCreateRole}
        width={1000}
        onCancel={() => setOpenCreateRole(false)}
      >
        <CreateRoleForm
          form={form}
          role={role}
          setOpenCreateRole={setOpenCreateRole}
          setAddedRole={setAddedRole}
        />
      </Modal>
      <Form
        {...formItemLayout}
        form={form}
        onFinish={onFinishForm}
        layout="vertical"
      >
        <Form.Item
          rules={[
            {
              required: true,
            },
          ]}
          label={"Name:"}
          labelAlign="left"
          name="name"
        >
          <Input placeholder="Please input the name" disabled />
        </Form.Item>
        <Form.Item
          rules={[
            {
              required: true,
            },
          ]}
          label={"Email:"}
          labelAlign="left"
          name="email"
        >
          <Input placeholder="Please input the email" disabled />
        </Form.Item>
        <Form.Item
          rules={[
            {
              required: true,
            },
          ]}
          label={"Institution:"}
          labelAlign="left"
          name="institution"
        >
          <Input placeholder="Please input the institution" disabled />
        </Form.Item>
        <Form.Item
          disabled
          label={"Department:"}
          labelAlign="left"
          name="department"
        >
          {form.getFieldValue()?.department?.map((item, index) => {
            return (
              <Tag color="geekblue" key={index}>
                {item}
              </Tag>
            );
          })}
        </Form.Item>
        <Form.Item label={"Position:"} labelAlign="left" name="position">
          {form.getFieldValue().position?.length > 40 ? (
            <Tooltip
              style={{ width: "300px" }}
              title={form.getFieldValue().position}
            >
              {
                <Input
                  value={form.getFieldValue().position}
                  placeholder="Please input the position"
                  disabled={
                    form.getFieldValue("mapped_profile_id") ? true : false
                  }
                />
              }
            </Tooltip>
          ) : (
            <Input
              placeholder="Please input the position"
              disabled={form.getFieldValue("mapped_profile_id") ? true : false}
            />
          )}
        </Form.Item>
        <Form.Item
          label={"Personal page:"}
          labelAlign="left"
          name="profile_url"
        >
          <Input
            placeholder="Please input the homepage"
            disabled={form.getFieldValue("mapped_profile_id") ? true : false}
          />
        </Form.Item>
        <Form.Item
          label={"Mapped profile:"}
          labelAlign="left"
          name="mapped_profile_id"
        >
          <SelectMappedProfile
            placeholder="Search for a faculty profile"
            functionSearch={getSearchAuthors}
            form={form}
            mappedProfile={
              profileData.mapped_profile_id
                ? {
                    photo: form.getFieldValue("photo"),
                    name: form.getFieldValue("name"),
                    department: {
                      inst_name: form.getFieldValue("institution"),
                    },
                    position: form.getFieldValue("position"),
                  }
                : null
            }
            profileData={profileData}
          />
        </Form.Item>
        <Form.Item
          rules={[
            {
              required: true,
            },
          ]}
          label={"Account status:"}
          labelAlign="left"
          name="activate"
        >
          <Radio.Group>
            <Radio value={1}>Enable</Radio>
            <Radio value={2}>Disable</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item
          rules={[
            {
              required: true,
            },
          ]}
          label={"Roles:"}
          labelAlign="left"
          name="role"
        >
          <Roles
            form={form}
            data={form.getFieldsValue()}
            setOpenCreateRole={setOpenCreateRole}
          />
        </Form.Item>
        <div className={styles["update-button"]}>
          <Button htmlType="submit" type="primary">
            Update
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default FormUpdate;
